// extracted by mini-css-extract-plugin
export default {"formDiv":"registerConfirm_formDiv__DI0zW","title":"registerConfirm_title__69x4B","subtitle":"registerConfirm_subtitle__VzdDX"};